<div class="card">
	<div class="card-body text-center">
		<div class="d-flex justify-content-around align-items-center">
			<div>
				<span class="card-text">{{ model.totalActivePersonnel | number }} Personnel</span>
				<fa-icon [icon]="faUsers" class="faTitle"></fa-icon>
			</div>
			<div>
				<span class="card-text">{{ model.totalActiveSites | number }} Sites</span>
				<fa-icon [icon]="faMapMarkedAlt" class="faTitle"></fa-icon>
			</div>
			<span></span>
			<h3 class="m-0">{{ model.emergencyEventName }}</h3>
			<span></span>
			<div>
				<span class="card-text">{{ model.totalActiveAssets | number }} Assets</span>
				<fa-icon [icon]="faTruck" class="faTitle"></fa-icon>
			</div>
			<div>
				<span class="card-text">{{ model.totalNumberOfDispenseEvents | number }} Dispenses</span>
				<fa-icon [icon]="faGasPump" class="faTitle"></fa-icon>
			</div>
		</div>
	</div>
</div>
